export const DETAILS = 'details'
export const EPISODES = 'episodes'
export const INFO = 'info'
